module.exports = __webpack_public_path__ + "assets/img/answer-off.16640c0d.svg";